var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3"},[_c('v-switch',{staticClass:"mt-0",attrs:{"input-value":_vm.options.allowJoin,"label":"Permitir que os convidados entrem no grupo"},on:{"change":function($event){return _vm.setValue('allowJoin', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }